import { readFragment } from '~publish/graphql'
import { getChannelNameForDisplay } from '~publish/helpers/getChannelNameForDisplay'
import { draftActionLabels } from '~publish/helpers/posts/draftActionLabels'
import { useDateTimeFormatter } from '~publish/hooks/useDateTimeFormatter'

import { useMetadataTitle, usePostData } from '../PostCardContext'
import { PostMediaAsset_Asset } from '../PostMedia/PostMediaAsset'

const DEFAULT_LABELS = {
  editLabel: 'Edit post',
  moreActionsLabel: 'More actions',
}

export function useDraftActionLabels(): {
  editLabel: string
  moreActionsLabel: string
} {
  const post = usePostData()
  const title = useMetadataTitle(post.metadata)
  const dateTimeFormatter = useDateTimeFormatter()

  if (post.status !== 'draft') {
    return DEFAULT_LABELS
  }

  return draftActionLabels({
    text: post.text,
    title,
    channelName: getChannelNameForDisplay(post.channel),
    createdAtLabel: dateTimeFormatter(post.createdAt, {
      includeTimeZone: false,
    }),
    assets: readFragment(PostMediaAsset_Asset, post.assets),
  })
}
